import { Box, ResponsiveContext, Text } from "grommet";
import { FormNext } from "grommet-icons";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { LocationItemComponent } from "./location-item.component";
import { v4 as uuidv4 } from 'uuid';
import { useFlags } from "launchdarkly-react-client-sdk";
import { updatePageHistory } from './page-history';
import { getCookie } from './../utils/cookie';
import {Steps} from './steps';

declare var rudderanalytics: any;
if (
  !(
    typeof rudderanalytics == 'undefined'
    || rudderanalytics == null
    || rudderanalytics === undefined
    || rudderanalytics === ''
  )
) {
  console.log("Calculator Main Page");
  rudderanalytics.page('Calculator Main Page',{
    integrations: {
      Amplitude: {
        session_id: getCookie('session_id')
      }
    }
  });
}

updatePageHistory('Calculator Main Page');

export const getFontSize = (size: string) => {
  switch (size) {
    case 'large': {
      return {
        xxSmall: '0.5rem',
        xSmall: '0.75rem',
        small: '1.05rem',
        medium: '1rem',
        large: '1.25rem',
        xLarge: '1.5rem',
        xxLarge: '1.75rem',
        subtitle: '2rem',
        title: '2.5rem'
      }
    }
    case 'medium': {
      return {
        xxSmall: '0.5rem',
        xSmall: '0.625rem',
        small: '1.05rem',
        medium: '0.825rem',
        large: '1rem',
        xLarge: '1.25rem',
        xxLarge: '1.5rem',
        subtitle: '1.75rem',
        title: '2rem',
      }
    }
    default: {
      return {
        xxSmall: '0.5rem',
        xSmall: '0.625rem',
        small: '1.05rem',
        medium: '0.825rem',
        large: '1rem',
        xLarge: '1.25rem',
        xxLarge: '1.5rem',
        subtitle: '1.75rem',
        title: '2rem',
      }
    }
  }
}

export const FastQuoteComponent = ({ actionButton }: any) => {

  const size = useContext(ResponsiveContext);
  const fontSize = getFontSize(size);

  const [hasError, setHasError] = useState(false);
  const [isSubmitted, setSubmitted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [locations, setLocations] = useState<any>([]);
  const { showLegumeAdditionPractice } = useFlags();
  const locationRef = useRef<any>();

  const addNewLocation = () => {
    const location = {
      id: uuidv4(),
      typeOfLand: 'nonIrrigated',
      typeOfLandRange: 'nonIrrigated',
      county: '',
      state: '',
      rowCropArea: '',
      pastureLandArea: '',
      practices: {
        reducedTillageNoTillage: false,
        coverCropping: false,
        nitrogenReduction: false,
        legumeAddition: false,
        improvedGrazing: false,
        seeding: false,
        fertilization: false
      }
    };
    setLocations([...locations, location]);
  };

  useEffect(() => {
    if (!locations?.length) {
      addNewLocation();
    }
  }, []);

  return (
    <Box width='fit-content' justify={'center'} className="QuotingTool">
      {
        showModal && (
            <div className="modal-window" onClick={()=> setShowModal(false)}>
              <div className="modal-inner" onClick={(e) => e.stopPropagation() }>
                <div className="close" onClick={()=>setShowModal(false)}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.79387 7.79304C8.18439 7.40252 8.81756 7.40252 9.20808 7.79304L16.2081 14.793C16.5986 15.1836 16.5986 15.8167 16.2081 16.2073C15.8176 16.5978 15.1844 16.5978 14.7939 16.2073L7.79387 9.20726C7.40335 8.81673 7.40335 8.18357 7.79387 7.79304Z" fill="#282828"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.79286 14.7929L14.7929 7.79289C15.1834 7.40237 15.8166 7.40237 16.2071 7.79289C16.5976 8.18342 16.5976 8.81658 16.2071 9.20711L9.20708 16.2071C8.81655 16.5976 8.18339 16.5976 7.79286 16.2071C7.40234 15.8166 7.40234 15.1834 7.79286 14.7929Z" fill="#282828"/>
                  </svg>
                </div>
                <h2>
                  Opportunity for you!
                </h2>
                <p>
                  Do you currently plant cover crops and would you consider adding a legume species to your mix?
                  <br /><br />
                  If so, click on the “Yes, please” button to contact an Agoro Carbon Agronomist who can calculate the value of adding legumes to your cover crop program.
                </p>        
                <div className="buttons">
                  <div className="button" onClick={()=>setShowModal(false)}>
                    No, Thank you
                  </div>
                  <a className="button" href="https://agorocarbonalliance.com/contact/farmers-ranchers/">
                    Yes, please!
                  </a>
                </div>
              </div>
            </div>
        ) 
      }
      <form id="calculate-form">
        <Box
          id={'quoteForm'}
          direction='row'
          height={'fit-content'}
          width={'62rem'}
          margin={'1rem'}
          // overflow={{ vertical: 'auto' }}
          className={'hideScrollBox'}
        >
          <Box
            className={'hideScrollBox'}
            pad={'0 2rem 0 2rem'}
            direction='column'
            height={'fit-content'}
            background={'white'}
            style={{
              maxWidth: '580px',
              margin: 'auto',
            }}
          >
            <h1 style={{ marginTop: '32px' }} className="ContactForm__CenterHeader">
              <Text weight={800} size={fontSize.title} textAlign={'center'} className="QuotingTool__Header">
                Calculate Your Carbon Potential
              </Text>
            </h1>
            <Text
              color={'#808080'}
              margin={'0.5rem 0 0.5rem 0'}
              textAlign={'justify'}
            >
              Start typing your location and select the correct value from the list, then input the size of your farm or ranch and select the appropriate practices and receive an instant carbon potential estimate.
            </Text>
            <Steps step={1} />

            {showLegumeAdditionPractice && <Box style={{
              background: 'rgba(27, 124, 61, 0.15)',
              display: 'none',
              padding: '16px 24px',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <Text
                style={{
                  color: '#1B7C3D',
                  fontWeight: 'normal',
                  lineHeight: '120%'

                }}
                margin={'0 0 0.5rem 0'}
                textAlign={'justify'}
              >
                The <span style={{
                  fontWeight: '900',
                }}>legume addition</span> practice will allow more producers to participate in the carbon market by improving their cover crop practice.
              </Text>
            </Box>}

            <Box style={{ minHeight: 'unset' }}>
              {locations && locations.map((location: any) => {
                return (
                  <LocationItemComponent
                    ref={locationRef}
                    key={location.id}
                    data={location}
                    isSubmitted={isSubmitted}
                    setShowModal = {setShowModal}
                    updateLocation={(location: any) => {
                      setLocations(locations.map((i: any) => {
                        if (i.id === location.id) {
                          return location;
                        }
                        return i;
                      }));
                    }}
                  />
                );
              })}
            </Box>

            {/* Disclaimer text */}
            <Box style={{ marginTop: '0' }}>
                <Text
                  color={'#808080'}
                  margin={'0.5rem 0 0.5rem 0'}
                  textAlign={'justify'}
                  style={{
                    fontSize: '12px',
                    lineHeight: '16px'
                  }}
                >
                  *The above represents an example payout schedule using an estimated amount of sequestered carbon per acre, annually. Please contact your Agoro Carbon TM Sales Representative or Agronomist for more details on estimated carbon sequestration potential on your farm or ranch. Any results from the use of this calculator are indicative estimates only and are not guaranteed in any way by Agoro Carbon. Any decisions based on the results of this calculator are taken by you at your own risk and without any liability for Agoro Carbon. 
                </Text>
              </Box>
            <Box
              style={{
                display: 'flex',
                alignItems: 'center'
              }}>
              <Box
                style={{ minHeight: 'unset', display: 'flex', alignItems: 'center' }}
                className="QuotingTool__GotoTheNextStep"
                background={'#fff'}
                alignContent={'center'}
                width={'fit-content'}
                margin={'2rem'}
                direction={'row'}
                onClick={async () => {
                  setSubmitted(true);
                  setTimeout(() => {
                    const isInvalid = locationRef!.current!.hasError();
                    if (isInvalid) {
                      setHasError(true);
                      document.getElementById('quoteForm')!.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                    } else {
                      setHasError(false);
                      actionButton(locations);
                      // Send to RudderStack
                      if (
                        !(
                          typeof rudderanalytics == 'undefined'
                          || rudderanalytics == null
                          || rudderanalytics === undefined
                          || rudderanalytics === ''
                        )
                      ) {
                        console.log("Calculator Go to Second Step");
                        rudderanalytics.page('Calculator Go to Second Step',{
                          integrations: {
                            Amplitude: {
                              session_id: getCookie('session_id')
                            }
                          }
                        });
                      }
                      updatePageHistory('Calculator Go to Second Step');
                    }
                  }, 100);
                }}
              >
                <Text>
                  Go to the next step
                </Text>
                <FormNext
                  color={'#282828'}
                  size={'30px'}
                  style={{ marginLeft: '0.75rem' }}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </form>
    </Box>
  )
}